// extracted by mini-css-extract-plugin
export default {"icon":"SlashCommandMenu-module__icon--aJ3dI","tooltipTarget":"SlashCommandMenu-module__tooltipTarget--8rwrK","dropzone":"SlashCommandMenu-module__dropzone--tMC6J"};